<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
    import SettingsPageLayout from '@/js/components/settings/SettingsPageLayout.vue';
</script>
<template>
    <SettingsPageLayout>
        <template #header>
            <h1 class="heading-lg-light">{{ __('back-office-overview') }}</h1>
        </template>
        <template #content>...</template>
    </SettingsPageLayout>
</template>
